import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Router, Route, Switch, Link, NavLink, Redirect} from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';
import FontAwesome from 'react-fontawesome';
import Intro from './components/Intro';
import PlotMap from './components/PlotMap';
import PlotMap2 from './components/PlotMap2';
import Home from './components/Home';
import Categories from './components/Categories';
import Category from './components/Category';
import Sections from './components/Sections';
import Vendors from './components/Vendors';


import Locate from './components/Locate';
import SpecialDish from './components/SpecialDish';
import Listing from './components/Listing';
import Cart from './components/Cart';
import Checkout from './components/Checkout';
import ChangeAddress from './components/ChangeAddress';
import AddAddress from './components/AddAddress';
import AddAddress2 from './components/AddAddress2';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import SmsVerification2 from './components/SmsVerification2';
import Register from './components/Register';
import SmsVerification from './components/SmsVerification';
import LocateInMap from './components/LocateInMap';
import Profile from './components/Profile';
import AccountSettings from './components/AccountSettings';
import ChangePassword from './components/ChangePassword';
import CustomerAddresses from './components/CustomerAddresses';
import CustomerAddressDetails from './components/CustomerAddressDetails';
import CustomerOrders from './components/CustomerOrders';
import CustomerOrdersDetails from './components/CustomerOrdersDetails';
import SubmitOrder from './components/SubmitOrder';
import CustomerOrderTrack from './components/CustomerOrderTrack';
import OnlinePay from './components/OnlinePay';
import Failure from './components/Failure';
import Map from './components/Map';
import SearchLocation from './components/SearchLocation';
import AboutUs from './components/AboutUs';
import CancellationRefunds from './components/CancellationRefunds';
import Disclaimer from './components/Disclaimer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsConditions';
import VerifyMobile from './components/VerifyMobile';
import SmsVerification3 from './components/SmsVerification3';
import SpecialOffers from './components/SpecialOffers';
import Reorder from './components/Reorder';
import ReOrder2 from './components/ReOrder2';
import SearchItems from './components/SearchItems';

//import AppRouter from './routers/AppRouter';
import 'normalize.css/normalize.css';
import './styles/styles.scss';
 
export const history = createBrowserHistory();

const NotFoundPage = () => (
    <div className="news-content" id="adver-page">
        <div className="container">
            <div className="ad-box not-found">
                <h1>404 Page Not Found</h1>
                <p>Sorry, the page you are looking for could not be found</p>
            </div>
        </div>
    </div>
);

const WebContent = (
    <Router history={history}>
        <div>
            <Switch>
                <Route path='/' component={Intro} exact={true} />
                <Route path='/map' component={PlotMap} exact={true} />
                <Route path='/map2/:id' component={PlotMap2} exact={true} />
                <Route path='/search' component={SearchLocation} exact={true} />
                <Route path='/home' component={Home} exact={true} />
                <Route path='/categories' component={Categories} exact={true} />
                <Route path='/category/:id' component={Category} exact={true} />
                <Route path='/sections/:id' component={Sections} exact={true} />
                <Route path='/vendor/:id' component={Vendors} exact={true} />
                <Route path='/cart' component={Cart} exact={true} />
                <Route path='/login' component={Login} exact={true} />
                <Route path='/forgot-password' component={ForgotPassword} exact={true} />
                <Route path='/sms_verification2' component={SmsVerification2} exact={true} />
                <Route path='/change_password' component={ChangePassword} exact={true} />
                <Route path='/register' component={Register} exact={true} />
                <Route path='/sms_verification' component={SmsVerification} exact={true} />
                <Route path='/checkout' component={Checkout} exact={true} />
                <Route path='/profile' component={Profile} exact={true} />
                <Route path='/orders' component={CustomerOrders} exact={true} />
                <Route path='/ordertrack/:id/:showModal' component={CustomerOrderTrack} exact={true} />
                <Route path='/ordertrack/:id' component={CustomerOrderTrack} exact={true} />
                <Route path='/orderdetails/:id' component={CustomerOrdersDetails} exact={true} />
                <Route path='/addresses' component={CustomerAddresses} exact={true} />
                <Route path='/addressdetails/:id' component={CustomerAddressDetails} exact={true} />
                <Route path='/addaddress2' component={AddAddress2} exact={true} />
                <Route path='/account_settings' component={AccountSettings} exact={true} />
                <Route path='/changeaddress' component={ChangeAddress} exact={true} />
                <Route path='/addaddress' component={AddAddress} exact={true} />
                <Route path='/submit_order' component={SubmitOrder} exact={true} />
                <Route path='/pay/:id' component={OnlinePay} exact={true} />
                <Route path='/failure' component={Failure} exact={true} />
                <Route path='/verifyMobile' component={VerifyMobile} exact={true} />
                <Route path='/smsverifyMobile' component={SmsVerification3} exact={true} />
                <Route path='/reorder' component={Reorder} exact={true} />
                <Route path='/reorder/:id' component={ReOrder2} exact={true} />
                <Route path='/search/:search_text' component={SearchItems} exact={true} />

                {/*<Route path='/locateinmap' component={LocateInMap} exact={true} />*/}
                {/*<Route path='/map' component={Map} exact={true} />*/}
                <Route path='/about-us' component={AboutUs} exact={true} />
                <Route path='/cancellation-and-refunds' component={CancellationRefunds} exact={true} />
                <Route path='/disclaimer' component={Disclaimer} exact={true} />
                <Route path='/privacy-policy' component={PrivacyPolicy} exact={true} />
                <Route path='/terms-and-conditions' component={TermsConditions} exact={true} />
                <Route path='/special-offers' component={SpecialOffers} exact={true} />
                <Route component={NotFoundPage} />
            </Switch>
        </div>
    </Router>
);

//export default App;
ReactDOM.render(WebContent, document.getElementById('app'));


// WEBPACK FOOTER //
// ./src/app.js